import { render, staticRenderFns } from "./LearningObjectiveTile.vue?vue&type=template&id=346dea4c"
import script from "./LearningObjectiveTile.vue?vue&type=script&lang=js"
export * from "./LearningObjectiveTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports